import { z } from "zod";
import {
  EPaycardOnboardingStatus,
  EPublicKYCStatus,
  ESSNVerificationStatus,
} from "@zeal/common";

export const workerPaycardOnboardingWebhookSchema = z.object({
  test: z.boolean(),
  companyID: z.string(),
  employeeID: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  kyc_status: z.nativeEnum(EPublicKYCStatus).nullable(),
  ssn_verification_status: z.nativeEnum(ESSNVerificationStatus).nullable(),
  paycard_onboarding_status: z.nativeEnum(EPaycardOnboardingStatus).nullable(),
  business_name: z.string(),
});

export const workerPaycardOnboardingWebhookRequestSchema = z.object({
  url: z.string(),
  testMode: z.boolean(),
});

export type TWorkerPaycardOnboardingWebhookRequest = z.infer<
  typeof workerPaycardOnboardingWebhookRequestSchema
>;
export type TWorkerPaycardOnboardingWebhookBody = z.infer<
  typeof workerPaycardOnboardingWebhookSchema
>;
